export default __webpack_public_path__ + "static/media/timer.d5720f40.svg";